const containsContext = (context) => window.location?.search?.includes(context) === true;

export function pushURLContext(context) {
    if (!containsContext(context)) {
        window.history.pushState({}, '', context);
    }
}

export function popURLContext(context) {
    if (containsContext(context)) {
        window.history.pushState({}, '', window.location.pathname);
    }
}
